export const getCenter = ({ latitude, longDisplacement, longitude }) => ({
  lat: latitude,
  lng: longDisplacement ? longitude - longDisplacement : longitude,
});
